import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  className?: string;
  type?: 'button' | 'submit' | 'reset';
}

const Button: React.FC<ButtonProps> = ({ className = '', children, ...props }) => {
  return (
    <button className={`btn btn-primary ${className}`} {...props}>
      {children}
    </button>
  );
};

export default Button; 